import { toast } from 'react-toastify'
import * as actionTypes from './actionTypes'
import creditoService from '../../api/creditoService'
import { decryptJsonValuesRecursive } from '../../util/cryptoUtils'

export const setCreditos = (creditos) => {
  return { type: actionTypes.LOAD_CREDITOS, payload: { creditos } }
}

export const setCredito = (credito) => {
  return { type: actionTypes.LOAD_CREDITO, payload: { credito } }
}

const loadingCreditos = (loading) => {
  return { type: actionTypes.LOADING_CREDITOS, payload: { loading } }
}


const loadingCredito = (loading) => {
  return { type: actionTypes.LOADING_CREDITO, payload: { loading } }
}

const loadingCuotas = (loading) => {
  return { type: actionTypes.LOADING_CUOTAS, payload: { loading } }
}

export const setCuotas = (cuotas) => {
  return { type: actionTypes.LOAD_CUOTAS, payload: { cuotas } }
}

export const getCreditos = () => async (dispatch) => {
  dispatch(loadingCreditos(true))
  try {
    let response = await creditoService.listCreditos()
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY)
    dispatch(setCreditos(response.data.creditos))
    dispatch(loadingCreditos(false))
  } catch (error) {
    dispatch(loadingCreditos(false))
    toast.error(error)
  }
}

export const getCredito = (request) => async (dispatch) => {
  dispatch(loadingCredito(true))
  try {
    let response = await creditoService.creditoDetail(request)
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY)
    dispatch(setCredito(response.data.credito))
    dispatch(loadingCredito(false))
  } catch (error) {
    dispatch(loadingCredito(false))
    toast.error(error)
  }
}

export const getCuotas = (request) => async (dispatch) => {
  dispatch(loadingCuotas(true))
  try {
    let response = await creditoService.listCuotas(request)
    response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY)
    dispatch(setCuotas(response.data.cuotas))
    dispatch(loadingCuotas(false))
  } catch (error) {
    dispatch(loadingCuotas(false))
    toast.error(error)
  }
}
